/** Parse admin-entered product sizes (comma, semicolon, or newline separated). */
export function parseProductSizes(raw) {
  if (raw == null || raw === "") return [];
  if (Array.isArray(raw)) {
    return raw.map((s) => String(s).trim()).filter(Boolean);
  }
  return String(raw)
    .split(/[,;\n]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function formatProductSizes(list) {
  if (!list) return "";
  if (Array.isArray(list)) return list.map((s) => String(s).trim()).filter(Boolean).join(", ");
  return String(list).trim();
}

/** Unique cart key for a catalog product + size combination. */
export function catalogLineKey(productId, size = "") {
  const pid = String(productId || "").trim();
  const sz = String(size || "").trim();
  if (!pid) return "";
  if (sz) return `catalog:${pid}:${sz}`;
  return pid;
}

export function catalogProductIdFromLineKey(key, row) {
  if (row?.catalogProductId) return row.catalogProductId;
  const m = String(key || "").match(/^catalog:([^:]+):/);
  if (m) return m[1];
  return key;
}

/** Show only the size label in UI (strip duplicated product name prefix). */
export function formatLineSizeDisplay(size, productName) {
  const s = String(size || "").trim();
  if (!s) return "";
  const name = String(productName || "").trim();
  const nameBase = name.replace(/\s*\([^)]*\)\s*$/, "").trim();
  const prefixes = [name, nameBase].filter((p, i, arr) => p && arr.indexOf(p) === i);
  for (const prefix of prefixes) {
    if (s.toLowerCase().startsWith(prefix.toLowerCase())) {
      const rest = s.slice(prefix.length).trim();
      if (rest) return rest;
    }
  }
  return s;
}

export function lineSizeLabel(lineKey, row) {
  const fromRow = formatLineSizeDisplay(row?.size, row?.name);
  if (fromRow) return fromRow;
  const m = String(lineKey || "").match(/^catalog:[^:]+:(.+)$/);
  if (m) return formatLineSizeDisplay(m[1], row?.name);
  return "";
}
